import { useState, useEffect } from "react";
import { Layout } from "antd";
import AppSidebar from "layout/AppSidebar";
import AppHeader from "./AppHeader";
import { merchantPermission } from "../requests/auth";
import logo from "assets/images/bbps-logo.png";
import logoIcon from "assets/images/favicon.png";
import { HiMenuAlt2 } from "react-icons/hi";
const { Content } = Layout;

const AppLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [allPermission, setAllPermission] = useState(false);
  const [permission, setPermission] = useState({});

  const handlePermission = async () => {
    try {
      const res = await merchantPermission();

      setAllPermission(res.data.data.all_permission);
      if (res.data.status === "1") {
        setPermission(res.data.data || {});
      } else {
        setPermission({});
      }
    } catch (err) {
      console.error("Error fetching permissions:", err);
    }
  };

  useEffect(() => {
    handlePermission();
  }, []);

  return (
    // <Layout>
    //   {allPermission && (
    //     <>
    //       <div
    //         className="app-sidebar justify-between align-items-center menu_none"
    //         theme="light "
    //       >
    //         <img src={logo} className="logo logo_menus" alt="Logo" />

    //         <HiMenuAlt2
    //           set="light"
    //           width={24}
    //           height={24}
    //           className="humburger"
    //         />
    //       </div>
    //     </>
    //   )}
    //   {permission.dashboard === "true" && (
    //     <AppSidebar
    //       isCollapsed={isCollapsed}
    //       toggleCollapse={() => setIsCollapsed(!isCollapsed)}
    //     />
    //   )}
    //   <Layout className={`main ${isCollapsed ? "main-expanded" : ""}`}>
    //     {permission.dashboard === "true" && <AppHeader />}
    //     <Content>{children}</Content>
    //   </Layout>
    // </Layout>
    
     <Layout>
      {(allPermission || permission.dashboard === "true") && (
        <AppSidebar
          isCollapsed={isCollapsed}
          toggleCollapse={() => setIsCollapsed(!isCollapsed)}
          permission={permission}
        />
      )}
      <Layout className={`main ${isCollapsed ? "main-expanded" : ""}`}>
        {(allPermission || permission.dashboard === "true") && <AppHeader />}
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
